import { CloseOutlined, ExpandLess, ExpandMore } from '@mui/icons-material'

import {
  Box,
  Button,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Stack
} from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { isBusinessURL } from '../../../_helpers/routes'
import { ITab } from '../../../_models/tabsInterface'
import LanguageSelector from '../../../components/languageSelector'
import { headerTabs } from '../items'

interface IMainDrawerProps {
  windowParam?: () => Window
  handleDrawerToggle: () => void
  mobileOpen: boolean
  handleNavigate: (redirectionPath: string, state?: Record<string, unknown>) => void
}
interface IUserType {
  title: string
  subtitle: string
  handleSelectUserType?: () => void
  logo: JSX.Element
}

const MainDrawer = (props: IMainDrawerProps) => {
  const { t } = useTranslation()
  const { windowParam, handleDrawerToggle, handleNavigate, mobileOpen } = props
  const container = windowParam !== undefined ? () => windowParam().document.body : undefined
  const navigate = useNavigate()
  const drawerWidth = '100vw'

  const handleClickOnListItem = (item: ITab) => {
    handleDrawerToggle()
    if (isBusinessURL()) {
      window.location.replace(
        `${window.location.protocol}//${process.env.REACT_APP_BUSINESS_URL}${item.path}`,
      )
    } else navigate(item.path)
  }
  // Drawer - mobile view
  const drawer = (
    <>
      <Box onClick={handleDrawerToggle} sx={{ textAlign: 'end' }}>
        <Box>
          <IconButton
            color='primary'
            aria-label='open drawer'
            edge='end'
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { lg: 'none' } }}
          >
            <CloseOutlined />
          </IconButton>
        </Box>

        <List>
          {headerTabs.map((item: ITab) => (
            <ListItem key={item.id}>
              <ListItemButton
                sx={{ textAlign: 'center' }}
                onClick={() => handleClickOnListItem(item)}
              >
                <ListItemText primary={t(`publicLayout.${item.label}`)} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Box>
      <Stack sx={{ mx: 4 }}>
        <Box mb={2} display={'flex'} justifyContent={'center'}>
          <LanguageSelector />
        </Box>
        <Button variant='outlined' size='large' onClick={() => handleNavigate('/login')}>
          {t('publicLayout.signInBtn')}
        </Button>
        <Button
          variant='contained'
          sx={{ mt: 2, pl: 4 }}
          size='large'
          onClick={() => handleNavigate('/sign-up', { state: { userType: 'CUSTOMER' } })}
        >
          {t('publicLayout.startFreeButton')}
        </Button>
      </Stack>
    </>
  )
  return (
    <>
      <Drawer
        container={container}
        variant='temporary'
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{
          keepMounted: true,
        }}
        sx={{
          display: { xs: 'block', lg: 'none' },
          '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
        }}
      >
        {drawer}
      </Drawer>
    </>
  )
}

export default MainDrawer
